/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MediaErrorType {
    NotInDb = 0,
    NotOnFileSystem = 1,
    PptFormat = 2,
}
